@if (isShowingLoadingSpinner()) {
    <app-loading-spinner data-qa="search-loading-spinner"/>
} @else {
    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="search-form">
        <app-text-input #searchInput
                        [ariaLabel]="(isGlobalSearchView() ? 'SEARCH.GLOBAL_PLACEHOLDER' : 'SEARCH.PLACEHOLDER') | translate"
                        [placeholder]="(isGlobalSearchView() ? 'SEARCH.GLOBAL_PLACEHOLDER' : 'SEARCH.PLACEHOLDER') | translate"
                        autocomplete="on"
                        formControlName="keyword"
                        inputId="keyword"
                        qaTag="search-input">
            <app-icon [iconSize]="AppIconSize.SMALL"
                      [svgIcon]="isDarkMode() ? ICONS.FIND_SELECTED : ICONS.FIND_UNSELECTED"
                      appContentPrefix
                      data-qa="search-icon"/>
        </app-text-input>
    </form>
    <app-stored-searches [vaultId]="vaultId()"/>
    <div class="simple-search-container">
        @if (recentSearches(); as recentSearches) {
            @if (recentSearches.length > 0) {
                <h3 class="search-dashboard-title" data-qa="recent-searches-title">{{ 'LAST_SIMPLE_SEARCH_TITLE' | translate }}</h3>

                <ul class="list">
                    @for (search of recentSearches; track recentSearchIndex; let recentSearchIndex = $index) {
                        <li>
                            <button (doubleClick)="directSearch(search.searchTerm)"
                                    (singleClick)="fillInputWithRecentSearch(search.searchTerm)"
                                    [attr.data-qa]="'recent-search-'+ recentSearchIndex"
                                    appClick
                                    class="button button-list-item list-item">
                                <app-icon [iconSize]="AppIconSize.MEDIUM"
                                          [svgIcon]="isDarkMode() ? ICONS.FIND_SELECTED : ICONS.FIND_UNSELECTED"
                                          class="list-item-icon"
                                          data-qa="custom-search-icon"/>
                                <div class="list-item-title-group">
                                    <div [attr.data-qa]="'recent-search-title-' + recentSearchIndex" class="list-item-text list-item-title">{{ search.searchTerm }}</div>
                                    <div [attr.data-qa]="'recent-search-scope-' + recentSearchIndex"
                                         class="list-item-text list-item-subtitle">{{ search.vaultId ? getVaultNameByVaultId(search.vaultId) : ('GLOBAL_SEARCH_RESULT_LOCATION'|translate) }}
                                    </div>
                                </div>
                                <div class="list-item-badges">
                                    <span [attr.data-qa]="'recent-search-title-' + recentSearchIndex" class="list-item-count">{{ search.resultCount > 99 ? '99+' : search.resultCount }}</span>
                                </div>
                            </button>
                        </li>
                    }
                </ul>
            }
        }
    </div>
}
